<template>
  <b-form
    novalidate
    @submit.prevent="submit"
  >
    <validation-observer ref="categoryFormRef">
      <b-card>
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center"
          >
            <h3>Create new category</h3>
            <b-button
              type="submit"
              :disabled="submitting"
              variant="primary"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Category Name En"
              rules="required"
            >
              <b-form-group
                label="Category Name En"
                label-for="category-name-en"
              >
                <b-form-input
                  id="category-name-en"
                  v-model="category.en"
                  placeholder="Category Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Category Name Ar"
              rules="required"
            >
              <b-form-group
                label="Category Name Ar"
                label-for="category-name-ar"
              >
                <b-form-input
                  id="category-name-ar"
                  v-model="category.ar"
                  placeholder="Category Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </b-form>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const category = ref({
      en: '',
      ar: '',
    })

    const submitting = ref(false)
    const submit = async () => {
      try {
        const res = await ctx.refs.categoryFormRef.validate()
        if (!res) return
        submitting.value = true
        const createdCategoryResult = await ctx.root.$store.dispatch('business/createCategory', {
          businessId,
          categories: [{ name: category.value }],
        })
        const createdCategory = createdCategoryResult.data.data.data[0]
        await ctx.root.$store.dispatch('business/transitionCategory', {
          category: createdCategory,
          body: {
            action: 'APPROVE',
          },
        })
        ctx.emit('created')
        successNotification('Category created')
      } catch (error) {
        console.log(error)
      } finally {
        submitting.value = false
      }
    }
    return {
      submitting,
      submit,
      required,
      category,
    }
  },
}
</script>

<style>

</style>
